export const treeViewReducerKey = 'treeViewReducerKey';

export const treeViewSetSelectedTaxonomiesReducerType = 'treeViewSetSelectedTaxonomiesReducerType';
export const treeViewSetSelectedListExpandedReducerType = 'treeViewSetSelectedListExpandedReducerType';
export const treeViewSetTaxonomiesReducerType = 'treeViewSetTaxonomiesReducerType';
export const treeViewSetInitialConfigReducerType = 'treeViewSetInitialConfigReducerType';
export const treeViewSetSelectionOrderReducerType = 'treeViewSetSelectionOrderReducerType';

export const ALLOWED_TAGS_ARRAY = ['sub', 'sup', 'hi', 'i', 'br', 'span'];

// The sidebar selected-values panel is a landmark named by its own visible
// heading, matching the results filter lookup dialog. The wrapper (TreeView) and
// the heading (TreeViewSelected) live in different files, so the id is shared
// from here rather than duplicated as a literal in both.
export const SELECTED_PANEL_HEADING_ID = 'treeViewSelected-heading';
